import request from '@utils/axios-utils';
import { useQuery } from 'react-query';
import { ApiList, Port } from '@types';
import { useAuth } from '@providers/auth';

export function usePorts() {
  const { session } = useAuth();
  return useQuery<ApiList<Port>>(
    ['ports'],
    async () => {
      const response = await request({
        authorizationToken: session?.token,
        url: `/ports`,
        method: 'GET',
      });
      return response.data;
    },
    {
      enabled: session.status != 'loading',
    },
  );
}
